import { render, staticRenderFns } from "./LogBook.vue?vue&type=template&id=43be33cc&scoped=true&"
import script from "./LogBook.vue?vue&type=script&lang=js&"
export * from "./LogBook.vue?vue&type=script&lang=js&"
import style0 from "./LogBook.vue?vue&type=style&index=0&id=43be33cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be33cc",
  null
  
)

export default component.exports